import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Grid,
  Table,
  InputAdornment,
  tableCellClasses,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  LinearProgress,
  linearProgressClasses,
  styled,
  FormControl,
  Autocomplete,
  TablePagination,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { AttachFile, Delete, Edit } from "@mui/icons-material";
import Paper from "@mui/material/Paper";
import Swal from "sweetalert2";
import axios from "axios";
import colors from "../constants/Colors";
import { MuiColorInput } from "mui-color-input";
import { ProjectContext } from "../../Context/ProjectContext";
import CircularProgress from "@mui/material/CircularProgress";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.primary,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Projects = () => {
  const [name, setName] = useState("");
  const [logo, setLogo] = useState(null);
  const [organisation_id, setOrganisation_id] = useState();
  const [organisation_name, setOrganisation_name] = useState();
  const [coordinator, setCoordinator] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const [moderator, setModerator] = useState("");
  const [members, setMembers] = useState([]);
  const [rows, setRows] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState({
    id: null,
    name: "",
    organisation_id: null,
    organisation_name: "",
    coordinator: null,
    coordinator_details: [],
    members: [],
    members_details: [],
    moderator: "",
    moderator_details: [],
    logo: "",
    color: "",
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [openDialog, setOpenDialog] = useState(false);
  const [partners, setPartners] = useState([]);
  const [profile, setProfile] = useState(null);
  const partner_pic = Number(localStorage.getItem("user_id"));
  const project_id = localStorage.getItem("project_id");
  const token = localStorage.getItem("access_token");
  const [storedOrganisationName, setStoredOrganisationName] = useState(
    localStorage.getItem("organisation_name")
  );
  const [color, setColor] = useState();
  const { projects, setProjects, setSelectedProjectId } =
    useContext(ProjectContext);
  const [partnersInProject, setPartnersInProject] = useState([]);
  const role = localStorage.getItem("role");

  const handleChangeColor = (color) => {
    setColor(color);
  };

  useEffect(() => {
    const fetchPartners = async (setRows) => {
      try {
        const response = await axios.get(
          ` https://eutracker.rdiup.com/v1/partners/`
        );
        setPartners(
          response.data.map((partner) => ({ id: partner.id, ...partner }))
        );
        console.log("partners dataaaaaaaaa ********", response.data);
      } catch (error) {
        console.error("Failed to fetch partners", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch partners. Please try again.",
        });
      }
    };
    fetchPartners();
  }, []);

  const handleProjectChange = (selectedProject) => {
    if (selectedProject) {
      const storedOrganisationName = Number(
        localStorage.getItem("organisation_name")
      );

      let userRole = "none";

      if (
        selectedProject.coordinator &&
        selectedProject.coordinator === storedOrganisationName
      ) {
        userRole = "coordinator";
      }

      if (selectedProject.members_details) {
        const memberNames = selectedProject.members_details.map(
          (detail) => detail.id
        );

        if (memberNames.includes(storedOrganisationName)) {
          userRole = "member";
        }
      }

      if (
        selectedProject.moderator &&
        selectedProject.moderator === storedOrganisationName
      ) {
        userRole = "moderator";
      }

      if (
        selectedProject.moderator_details &&
        selectedProject.coordinator_details
      ) {
        const moderatorNames = Array.isArray(selectedProject.moderator_details)
          ? selectedProject.moderator_details.map((detail) =>
              detail.name.toLowerCase()
            )
          : [selectedProject.moderator_details.name.toLowerCase()];

        const coordinatorNames = Array.isArray(
          selectedProject.coordinator_details
        )
          ? selectedProject.coordinator_details.map((detail) =>
              detail.name.toLowerCase()
            )
          : [selectedProject.coordinator_details.name.toLowerCase()];

        if (
          moderatorNames.includes(storedOrganisationName) &&
          coordinatorNames.includes(storedOrganisationName)
        ) {
          userRole = "coordinator";
        }
      }

      localStorage.setItem("role", userRole);
      localStorage.setItem("project_id", selectedProject.id);
      localStorage.setItem("project_color", selectedProject.color);
      localStorage.setItem("logo", selectedProject.logo);
      setSelectedProjectId(selectedProject.id);
      window.location.href = "/define_partners";
    } else {
      localStorage.removeItem("project_id");
      localStorage.removeItem("role");
      setSelectedProjectId("");
    }
  };

  useEffect(() => {
    if (filteredProjects.length > 0) {
      getModerator(); // Call your function here once filteredProjects is updated
    }
  }, [filteredProjects]);

  useEffect(() => {
    const fetchPartnersInProject = async () => {
      if (!selectedProject?.id) return;

      try {
        const response = await axios.get(
          ` https://eutracker.rdiup.com/v1/projects/${selectedProject.id}/get_partners/`
        );
        setPartnersInProject(response.data);
        console.log("Partners in project:", response.data);
      } catch (error) {
        console.error("Error fetching partners for the project", error);
      }
    };

    fetchPartnersInProject();
  }, [selectedProject]);

  const handleEditClick = (projectId) => {
    const projectToEdit = getProjects.find(
      (project) => project.id === projectId
    );
    setSelectedProject(projectToEdit);
    setOpenDialog(true);
  };

  // useEffect(() => {
  //   const fetchPartnersByProject = async () => {
  //     try {
  //         // const response = await axios.get(` https://eutracker.rdiup.com/v1/projects/${selectedProject.id}/partners/`);
  //         const response = await axios.get(` https://eutracker.rdiup.com/v1/partners/`);
  //         setPartnersByProject(response.data.map((partner) => ({ id: partner.id, ...partner })));
  //         console.log("partners data ********", response.data);
  //     } catch (error) {
  //         console.error("Failed to fetch partners", error);
  //     }
  //   };
  //   if (selectedProject) {
  //     fetchPartnersByProject();
  //   }
  // }, [selectedProject.id]);

  const handleFileChange = (e) => {
    console.log("coord", coordinator);
    const file = e.target.files[0];
    setLogo(file); // Make sure this sets the file object
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const navigate = useNavigate();

  const addProject = async () => {
    if (!name || !organisation_id || !organisation_name || !coordinator) {
      Swal.fire(
        "Validation Error",
        "Please fill out all required fields",
        "warning"
      );
      return;
    }
    setLoading(true); // Always stop loading

    const formData = new FormData();
    formData.append("name", name.toUpperCase());
    formData.append("organisation_id", organisation_id);
    formData.append("organisation_name", organisation_name);
    formData.append("coordinator", coordinator);
    if (logo) {
      formData.append("logo", logo); // Ensure 'logo' is a File object
    }
    console.log("logo", logo);
    formData.append("color", color);
    formData.append("status", status);

    try {
      const response = await axios.post(
        " https://eutracker.rdiup.com/v1/projects/create/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 201) {
        Swal.fire("Success", "Project added successfully!", "success");
        setName("");
        setLogo(null);
        await fetchProjects();
        navigate("/projects");
      }
      //navigate("/projects");
    } catch (error) {
      console.error("There was an error adding the project!", error);

      let errorMessage = "An unexpected error occurred. Please try again.";
      if (error.response && error.response.data) {
        const errorDetails = error.response.data.details || {};
        errorMessage = errorDetails.name ? errorDetails.name[0] : errorMessage;
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
      });
    } finally {
      setLoading(false); // Always stop loading
    }
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(
          " https://eutracker.rdiup.com/v1/user/getProfile/",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Assuming you store the token in localStorage
            },
          }
        );
        setProfile(response.data.user);
        console.log("profile", response.data.user);
        localStorage.setItem("is_admin", response.data.user.is_admin);
      } catch (err) {
        console.log("Failed to fetch profile");
      }
    };

    fetchProfile();
  }, []);

  const fetchProjects = async () => {
    try {
      // Fetch all projects
      const response = await axios.get(
        " https://eutracker.rdiup.com/v1/projects/",
        {
          headers: {
            Authorization: `Bearer ${token}`, // Ensure to pass the token if required
          },
        }
      );
      const data = response.data;

      // Get stored organisation name
      const storedOrgName = localStorage.getItem("user_id");
      setStoredOrganisationName(storedOrgName);

      // Filter projects based on user role
      console.log("projectsss", data, storedOrgName);
      const filteredProjects = data.filter((project) => {
        const isCoordinator =
          project.coordinator_details &&
          (Array.isArray(project.coordinator_details)
            ? project.coordinator_details.some(
                (detail) => Number(detail.pic) === Number(storedOrgName)
              )
            : Number(project.coordinator_details.pic) ===
              Number(storedOrgName));

        const isMember =
          Array.isArray(project.members_details) &&
          project.members_details.some(
            (detail) => Number(detail.pic) === Number(storedOrgName)
          );

        const isModerator =
          project.moderator_details &&
          (Array.isArray(project.moderator_details)
            ? project.moderator_details.some(
                (detail) => Number(detail.pic) === Number(storedOrgName)
              )
            : Number(project.moderator_details.pic) === Number(storedOrgName));

        return isCoordinator || isMember || isModerator;
      });

      // Update state based on user role
      if (profile && profile.is_admin === true) {
        setProjects(data);
      } else {
        console.log("filterproecjt", filteredProjects);
        setProjects(filteredProjects);
      }
    } catch (error) {
      console.error(
        "Error fetching projects:",
        error.response ? error.response.data : error.message
      );
    }
  };
  useEffect(() => {
    fetchProjects();
  }, [profile, token]);

  const getModerator = async (projectId) => {
    const projectfiltered = filteredProjects.find(
      (proj) => proj.id === projectId
    );
    console.log('picc"', projectId, filteredProjects, project ? project : null);
    // Check if project exists and return the moderator pic, otherwise return null
    return projectfiltered ? projectfiltered.moderator_details.pic : null;
  };

  //   const fetchAllProjects = async () => {
  //     setLoading(true);
  //     try {
  //         // Fetch all projects from the API
  //         const response = await axios.get(' https://eutracker.rdiup.com/v1/projects/');
  //         const data = response.data;

  //         setProjects(data);

  //     } catch (error) {
  //         console.error('Error fetching projects:', error.response ? error.response.data : error.message);
  //     } finally {
  //         setLoading(false);
  //     }
  // };

  // Fetch projects data on component mount

  // const fetchProjects = async () => {
  //   try {
  //       const response = await axios.get(' https://eutracker.rdiup.com/v1/projects/');
  //       setRows(response.data.map((project) => ({ id: project.id, ...project })));
  //       setProjects(response.data.map((project) => ({ id: project.id, ...project })));

  //       console.log("projects",response.data);

  //   } catch (err) {
  //       console.log("Failed to fetch projects");
  //       console.error(err);
  //   }
  // };

  // useEffect(() => {
  //   fetchProjects();
  // }, []);

  const handleDeleteClick = (id) => async () => {
    console.log("remvoe");
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the project.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    // Check if the user confirmed the deletion
    if (result.isConfirmed) {
      console.log("Attempting to delete project with ID:", id);

      try {
        // Perform the delete request
        const response = await axios.delete(
          ` https://eutracker.rdiup.com/v1/projects/${id}/`
        );
        if (response.status === 204) {
          Swal.fire("Deleted!", "Project has been deleted.", "success");
          // Update the state to remove the deleted project
          setRows((prevRows) => prevRows.filter((row) => row.id !== id));
          fetchProjects(); // Ensure this function updates your project list
        } else {
          console.error("Unexpected response status:", response.status);
          Swal.fire("Error", "Unexpected error occurred.", "error");
        }
      } catch (error) {
        console.error(
          "There was an error deleting the project!",
          error.response?.data || error.message
        );
        Swal.fire("Error", "There was an error deleting the project.", "error");
      }
    }
  };
  const handleSaveClick = async () => {
    setOpenDialog(false); // Close the dialog if it's open

    // Show confirmation dialog first
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to save these changes?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "Cancel",
    });

    // If user confirms, proceed with the save operation
    if (result.isConfirmed) {
      const formData = new FormData();

      // Prepare the data, ensuring 'members' is a list of IDs
      const data = {
        name: selectedProject.name,
        organisation_id: selectedProject.organisation_id,
        organisation_name: selectedProject.organisation_name,
        coordinator: selectedProject.coordinator,
        moderator:
          selectedProject.moderator === "" ? null : selectedProject.moderator, // Handle empty string as null
        members: selectedProject.members || [], // Ensure it's a list of IDs
        color: selectedProject.color,
        status: selectedProject.status,
      };

      // Append JSON data to FormData
      formData.append("data", JSON.stringify(data));

      // If you have a file (logo), append it as well
      if (logo) {
        formData.append("logo", logo);
      }

      try {
        const response = await axios.put(
          ` https://eutracker.rdiup.com/v1/projects/${selectedProject.id}/update/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("Project updated successfully:", response.data);
        setSelectedProject(null);
        Swal.fire("Saved!", "Project has been updated.", "success");
        fetchProjects(); // Ensure this function updates your project list
        localStorage.setItem("project_color", selectedProject.color);
      } catch (error) {
        console.error(
          "Error updating project:",
          error.response?.data || error.message
        );
        Swal.fire("Error", "There was an error updating the project.", "error");
      }
    } else {
      // If user cancels, show a message or do nothing
      Swal.fire("Cancelled", "The project update was cancelled.", "info");
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedProject(null);
  };

  const getProjectPartners = (project) => {
    const picNumbers = [
      project.coordinator_details?.pic,
      project.moderator_details?.pic,
      ...project.members_details.map((member) => member.pic),
    ];

    return partners.filter((partner) => picNumbers.includes(partner.pic));
  };

  // Find the specific project by ID
  const project = projects.find((project) => project.id === project_id);
  const filteredPartners = project ? getProjectPartners(project) : [];

  console.log("filtered Prtners", filteredPartners);

  const partnersWithAddOption = [
    ...(selectedProject && selectedProject.id != null
      ? partnersInProject
      : partners),
    { id: "add-new-partner", name: "Add New Partner", pic: "" }, // Special option
  ];

  const getProjects = role === "superadmin" ? projects : projects || [];
  console.log("getproj", getProjects);

  return (
    <div>
      {profile && profile.is_admin == false ? (
        <></>
      ) : (
        <Grid
          container
          spacing={2}
          alignItems="center"
          sx={{ marginBottom: 10 }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <div style={{ textAlign: "left" }}>
                <span>
                  Name <span style={{ color: "red" }}>*</span>
                </span>
              </div>
              <TextField
                type="text"
                placeholder="Project name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                size="small"
                fullWidth
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <div style={{ textAlign: "left" }}>
                <span>
                  Grant ID <span style={{ color: "red" }}>*</span>
                </span>
              </div>
              <TextField
                type="text"
                placeholder="Org ID"
                value={organisation_id}
                onChange={(e) => setOrganisation_id(e.target.value)}
                size="small"
                fullWidth
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <div style={{ textAlign: "left" }}>
                <span>
                  Program Type <span style={{ color: "red" }}>*</span>
                </span>
              </div>
              <TextField
                type="text"
                placeholder="Org name"
                value={organisation_name}
                onChange={(e) => setOrganisation_name(e.target.value)}
                size="small"
                fullWidth
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <div style={{ textAlign: "left" }}>
                <span>
                  Coordinator <span style={{ color: "red" }}>*</span>
                </span>
              </div>
              <Autocomplete
                disablePortal
                options={partnersWithAddOption}
                getOptionLabel={
                  (option) =>
                    option.id === "add-new-partner"
                      ? option.name // Display "Add New Partner"
                      : `${option.name} (${option.pic})` // Display name and pic for others
                }
                size="small"
                fullWidth
                value={filteredPartners.find(
                  (partner) => partner.id === coordinator
                )} // Correct value handling
                onChange={(event, newValue) => {
                  if (newValue?.id === "add-new-partner") {
                    navigate("/define_partners"); // Redirect to the partner creation page
                  } else if (newValue) {
                    setCoordinator(newValue.id); // Set the coordinator to the selected partner's ID
                  } /* else {
                    setCoordinator(""); // Reset if no value is selected
                  }  */
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Coordinator" />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <div style={{ textAlign: "left" }}>
                <span>Logo</span>
              </div>
              <TextField
                type="file"
                variant="outlined"
                onChange={handleFileChange}
                size="small"
                fullWidth
                InputProps={{
                  inputProps: {
                    accept: "image/*",
                  },
                  startAdornment: (
                    <InputAdornment position="start">
                      <AttachFile />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <div style={{ textAlign: "left" }}>
                <span>Theme colors</span>
              </div>
              <MuiColorInput value={color} onChange={handleChangeColor} />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small">
              <div style={{ textAlign: "left", marginBottom: 6 }}>
                <span>Status</span>
              </div>
              <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                variant="outlined"
                displayEmpty
              >
                <MenuItem value="" disabled>
                  <em>Select status</em>
                </MenuItem>
                <MenuItem value="building">Building</MenuItem>
                <MenuItem value="approved">Approved</MenuItem>
                <MenuItem value="ongoing">Ongoing</MenuItem>
                <MenuItem value="ended">Ended</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#35698a", marginTop: 3 }}
              onClick={addProject}
              disabled={
                loading ||
                !name ||
                !organisation_name ||
                !organisation_id ||
                !coordinator
              }
              fullWidth
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Add Project"
              )}
            </Button>
          </Grid>
        </Grid>
      )}

      <br />

      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell></StyledTableCell>
                <StyledTableCell>Name</StyledTableCell>
                <StyledTableCell>Logo</StyledTableCell>
                <StyledTableCell align="left">Grant ID</StyledTableCell>
                <StyledTableCell align="left">Program type</StyledTableCell>
                <StyledTableCell align="left">Coordinator</StyledTableCell>
                <StyledTableCell align="left">Moderator</StyledTableCell>
                <StyledTableCell align="left">Partners</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getProjects
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((project) => (
                  <StyledTableRow key={project.id}>
                    {/* {role !== "none" ? (
                      <>
                        {partner_pic === project.coordinator_details?.pic ? (
                          // Coordinator edit button
                          <StyledTableCell>
                            <Grid container>
                              <IconButton
                                onClick={() => handleEditClick(project.id)}
                              >
                                <Edit color="primary" />
                              </IconButton>
                            </Grid>
                          </StyledTableCell>
                        ) : project.moderator_details &&
                          // Moderator edit button if moderator exists and pic matches
                          partner_pic === project.moderator_details?.pic ? (
                          <StyledTableCell>
                            <Grid container>
                              <IconButton
                                onClick={() => handleEditClick(project.id)}
                              >
                                <Edit color="primary" />
                              </IconButton>
                            </Grid>
                          </StyledTableCell>
                        ) : project.members_details &&
                          project.members_details.length > 0 ? (
                          // Handle members if required
                          <StyledTableCell></StyledTableCell>
                        ) : null}
                      </>
                    ) : (
                      // Default case with both Edit and Delete buttons
                      <StyledTableCell>
                        <Grid container>
                          <IconButton
                            onClick={() => handleEditClick(project.id)}
                          >
                            <Edit color="primary" />
                          </IconButton>
                          <IconButton
                            color="error"
                            onClick={() => handleDeleteClick(1)}
                          >
                            <Delete color="error" />
                          </IconButton>
                        </Grid>
                      </StyledTableCell>
                    )} */}

                    {role !== "none" ? (
                      partner_pic == project.coordinator_details?.pic ? (
                        // Coordinator edit button
                        <StyledTableCell>
                          <Grid container>
                            <IconButton
                              onClick={() => handleEditClick(project.id)}
                            >
                              <Edit color="primary" />
                            </IconButton>
                          </Grid>
                        </StyledTableCell>
                      ) : project.moderator_details &&
                        partner_pic === project.moderator_details?.pic ? (
                        // Moderator edit button if moderator exists and pic matches
                        <StyledTableCell>
                          <Grid container>
                            <IconButton
                              onClick={() => handleEditClick(project.id)}
                            >
                              <Edit color="primary" />
                            </IconButton>
                          </Grid>
                        </StyledTableCell>
                      ) : project.members_details &&
                        project.members_details.length > 0 ? (
                        // Handle members if necessary
                        <StyledTableCell></StyledTableCell>
                      ) : null
                    ) : (
                      // Default case with both Edit and Delete buttons for non-members
                      <StyledTableCell>
                        {
                          <Grid container>
                            <IconButton
                              onClick={() => handleEditClick(project.id)}
                            >
                              <Edit color="primary" />
                            </IconButton>
                            <IconButton
                              color="error"
                              onClick={handleDeleteClick(project.id)}
                            >
                              <Delete color="error" />
                            </IconButton>
                          </Grid>
                        }
                      </StyledTableCell>
                    )}

                    <StyledTableCell component="th" scope="row">
                      {project.name}
                    </StyledTableCell>
                    <StyledTableCell>
                      <img
                        src={project.imageURL || "/default-image.png"}
                        alt="logo"
                        style={{
                          width: "100%",
                          height: "auto",
                          maxWidth: "80px",
                          maxHeight: "50px",
                          objectFit: "contain",
                          marginTop: 10,
                        }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {project.organisation_id}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {project.organisation_name}
                    </StyledTableCell>
                    <StyledTableCell align="left" sx={{ fontWeight: "600" }}>
                      {project.coordinator_details
                        ? project.coordinator_details.name
                        : "No Coordinator"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {project.moderator_details ? (
                        project.moderator_details.name
                      ) : (
                        <p>
                          Waiting for{" "}
                          {project.coordinator_details
                            ? project.coordinator_details.name
                            : "the coordinator"}{" "}
                          to add a moderator
                        </p>
                      )}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {Array.isArray(project.members_details) &&
                      project.members_details.length > 0 ? (
                        project.members_details
                          .map((member) => member.name)
                          .join(", ")
                      ) : (
                        <p style={{ color: "gray" }}>
                          Waiting for moderator to add members
                        </p>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
            {/* border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%; */}
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={getProjects.length} // modif pagination
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>Edit Project</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Edit the project details. Currently editing:{" "}
              {selectedProject?.name}
            </DialogContentText>

            {console.log("selected project", selectedProject)}

            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{ marginBottom: 10 }}
            >
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <div style={{ textAlign: "left" }}>
                    <span>Name</span>
                  </div>
                  <TextField
                    disabled={
                      profile &&
                      !profile.is_admin &&
                      (role === "coordinator" || role === "moderator")
                    }
                    type="text"
                    placeholder="Project name"
                    value={selectedProject?.name || ""}
                    onChange={(e) =>
                      setSelectedProject((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                    size="small"
                    fullWidth
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <div style={{ textAlign: "left" }}>
                    <span>Grant ID</span>
                  </div>
                  <TextField
                    disabled={
                      profile &&
                      !profile.is_admin &&
                      (role === "coordinator" || role === "moderator")
                    }
                    type="text"
                    placeholder="Org ID"
                    value={selectedProject?.organisation_id || ""}
                    onChange={(e) =>
                      setSelectedProject((prev) => ({
                        ...prev,
                        organisation_id: e.target.value,
                      }))
                    }
                    size="small"
                    fullWidth
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <div style={{ textAlign: "left" }}>
                    <span>Program type</span>
                  </div>
                  <TextField
                    disabled={
                      profile &&
                      !profile.is_admin &&
                      (role === "coordinator" || role === "moderator")
                    }
                    type="text"
                    placeholder="Org name"
                    value={selectedProject?.organisation_name || ""}
                    onChange={(e) =>
                      setSelectedProject((prev) => ({
                        ...prev,
                        organisation_name: e.target.value,
                      }))
                    }
                    size="small"
                    fullWidth
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <div style={{ textAlign: "left" }}>
                    <span>Coordinator</span>
                  </div>
                  <Autocomplete
                    disabled={
                      profile &&
                      !profile.is_admin &&
                      (role === "coordinator" || role === "moderator")
                    }
                    options={partnersWithAddOption}
                    size="small"
                    fullWidth
                    getOptionLabel={(option) =>
                      option.id === "add-new-partner"
                        ? option.name
                        : `${option.name} (${option.pic})`
                    }
                    value={
                      partnersWithAddOption.find(
                        (partner) => partner.id === selectedProject?.coordinator
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      if (newValue?.id === "add-new-partner") {
                        handleProjectChange(selectedProject);
                      } else {
                        setSelectedProject((prev) => ({
                          ...prev,
                          coordinator: newValue ? newValue.id : null,
                        }));
                      }
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <div style={{ textAlign: "left" }}>
                    <span>Logo</span>
                  </div>
                  <TextField
                    disabled={
                      role === "coordinator" && profile && !profile.is_admin
                    } // Disable for coordinator role unless admin
                    type="file"
                    variant="outlined"
                    onChange={handleFileChange} // Ensure handleFileChange is defined
                    size="small"
                    fullWidth
                    InputProps={{
                      inputProps: {
                        accept: "image/*",
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachFile />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <div style={{ textAlign: "left" }}>
                    <span>Theme color</span>
                  </div>
                  <MuiColorInput
                    disabled={
                      profile &&
                      !profile.is_admin &&
                      (role === "coordinator" || role === "moderator")
                    }
                    value={selectedProject?.color || ""}
                    onChange={(color) =>
                      setSelectedProject((prev) => ({ ...prev, color }))
                    }
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth size="small">
                  <div style={{ textAlign: "left", marginBottom: 4 }}>
                    <span>Status</span>
                  </div>
                  <Select
                    value={selectedProject?.status || ""}
                    onChange={(e) =>
                      setSelectedProject((prev) => ({
                        ...prev,
                        status: e.target.value,
                      }))
                    }
                    variant="outlined"
                    displayEmpty
                    disabled={
                      profile &&
                      !profile.is_admin &&
                      (role === "coordinator" || role === "moderator")
                    }
                  >
                    <MenuItem value="" disabled>
                      <em>Select status</em>
                    </MenuItem>
                    <MenuItem value="building">Building</MenuItem>
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="ongoing">Ongoing</MenuItem>
                    <MenuItem value="ended">Ended</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <div style={{ textAlign: "left" }}>
                    <span>Moderator</span>
                  </div>
                  <Autocomplete
                    disabled={role === "moderator"}
                    disablePortal
                    options={partnersWithAddOption}
                    size="small"
                    fullWidth
                    getOptionLabel={(option) =>
                      option.id === "add-new-partner"
                        ? option.name
                        : `${option.name} (${option.pic})`
                    }
                    value={
                      partnersWithAddOption.find(
                        (partner) => partner.id === selectedProject?.moderator
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      if (newValue?.id === "add-new-partner") {
                        navigate("/define_partners", {
                          state: { selectedProjectId: selectedProject.id },
                        });
                        handleProjectChange(selectedProject);
                      } else {
                        setSelectedProject((prev) => ({
                          ...prev,
                          moderator: newValue ? newValue.id : null,
                        }));
                      }
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <div style={{ textAlign: "left" }}>
                    <span>Members</span>
                  </div>
                  <Autocomplete
                    multiple
                    disablePortal
                    options={partnersWithAddOption}
                    size="small"
                    fullWidth
                    getOptionLabel={(option) =>
                      option.id === "add-new-partner"
                        ? option.name
                        : `${option.name} (${option.pic})`
                    }
                    value={
                      partnersWithAddOption.filter((partner) =>
                        selectedProject?.members?.includes(partner.id)
                      ) || []
                    }
                    onChange={(event, newValue) => {
                      if (
                        newValue.some(
                          (option) => option.id === "add-new-partner"
                        )
                      ) {
                        navigate("/define_partners");
                        handleProjectChange(selectedProject);
                      } else {
                        const filteredMembers = newValue
                          .map((p) => p.id)
                          .filter((id) => id !== selectedProject?.coordinator);
                        setSelectedProject((prev) => ({
                          ...prev,
                          members: filteredMembers,
                        }));
                      }
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSaveClick} sx={{ backgroundColor: "white" }}>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </div>
  );
};

export default Projects;
